import $ from "jquery";

// Create empty Array set for the filters
let typeFilter = [];
let rangeFilter = [];
let regionFilter = [];
let varietalFilter = [];
let wineProducts = [];

let appliedFilter = [];
let queryParams = {};

$(document).ready(function () {
    // Get the pathname to check for products page
    const pathname = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);

    if (pathname.indexOf("products") !== -1) {

        // Loop through the search parameters and store them in the object
        urlParams.forEach(function(value, key) {
            queryParams[key] = value;
        });

        wineProducts = $('.product-item');

        wineProducts.each(function () {
            $(this).addClass('fade-in');
            // Get data-attribute values
            const type = $(this).data('type-filter');
            const range = $(this).data('range');
            const region = $(this).data('region');
            const varietal = $(this).data('varietal');

            // Add unique values of all the attributes
            FetchUniqueAttributes(type, typeFilter);
            FetchUniqueAttributes(range, rangeFilter);
            FetchUniqueAttributes(region, regionFilter);
            FetchUniqueAttributes(varietal, varietalFilter);
        });

        injectFilters($('.wineRegionFilters'), regionFilter, 'region');
        injectFilters($('.wineRangeFilters'), rangeFilter, 'range');
        injectFilters($('.wineVarietalFilters'), varietalFilter, 'varietal');

        injectTypeFilter($('.wineTypeFilters'), typeFilter);

        $('.filter-button').on('click', function() {
            if($(this).hasClass('active-filter')) {
                $(this).removeClass('active-filter');
                $(this).find('i').remove();

                removeFilterItems(this);
            } else {
                // Create an <i> element
                const icon = $('<i>');

                // Add classes or attributes to the <i> element if needed
                icon.addClass('removeFilter-icon'); // Add a custom class for styling

                // Set the background image
                icon.css('background-image', 'url("/wp-content/themes/villamariawines-wp-theme/resources/icons/close.svg")');
                $(this).append(icon);
                $(this).addClass('active-filter');

                const filterObject = {
                    type: 'type-filter',
                    value: $(this).attr('data-type-filter').toLowerCase()
                }
                if(!checkFilterArray(appliedFilter,filterObject)) {
                    appliedFilter.push(filterObject);
                }

                filterByAttribute(appliedFilter);
            }
        });

        $(".filter-variants-button").on('click', function() {
            if ($(this).is(':checked')) {
                const attrName = this.dataset;
                const filterObject = {
                    type: Object.keys(attrName)[0],
                    value: $(this).attr('data-' + Object.keys(attrName)[0] + '').toLowerCase()
                }
                if (!checkFilterArray(appliedFilter, filterObject)) {
                    appliedFilter.push(filterObject);
                }
            } else {
                removeFilterItems(this);
            }
        });

        $("#products_apply_filters").on('click', function() {
            filterByAttribute(appliedFilter);
        });

        $('#underline_select').change(function () {
            const selectedValue = $(this).val();
            sortByAttribute(selectedValue);
        });

        if ($('#products_clear_filters') !== null) {
            $('#products_clear_filters').on('click', function() {
                resetFilter();
            })
        }

        // Trigger the url filter
        UpdateFilterBasedOnURL();
    }
});

function filterByAttribute(filterData) {
    if(appliedFilter.length > 0) {
        const typeFilterArray = filterData.filter(obj => obj.type === 'type-filter');
        const variationArray = filterData.filter(obj => obj.type !== 'type-filter');
        // Hide all div elements
        wineProducts.each(function () {
            $(this).hide();
        });

        // Show only the selected div elements
        wineProducts.each(function () {
            const wineItem = $(this);
            if(variationArray.length === 0 && typeFilterArray.length > 0 || typeFilterArray.length === 0 && variationArray.length > 0) {
                filterData.forEach(dataAttr => {
                    const {type, value} = dataAttr;
                    const attributeData = wineItem.data(type).split(','); // Split attribute values by comma
                    if (attributeData.includes(value)) { // Check if the value is included in the attribute data
                        $(this).show();
                    }
                });
            } else {
                typeFilterArray.forEach(typeAttr => {
                    const typeData = {
                        type: typeAttr.type,
                        value: typeAttr.value
                    };
                    variationArray.forEach(variationAttr => {
                        const variationData = {
                            type: variationAttr.type,
                            value: variationAttr.value
                        };
                        const typeAttrData = wineItem.data(typeData.type).split(','); // Split type attribute values by comma
                        const variationAttrData = wineItem.data(variationData.type).split(','); // Split other attribute values by comma
                        if (typeAttrData.includes(typeData.value) && variationAttrData.includes(variationData.value)) { // Check if the value is included in the attribute data
                            $(this).show();
                        }
                    });
                });
            }
        });
    }
}

function sortByAttribute(attribute) {
    if (attribute == 'name') {
        // Sort items based on data-name attribute
        wineProducts.sort(function (a, b) {
            const productA = $(a).data(attribute).toUpperCase();
            const productB = $(b).data(attribute).toUpperCase();
            return (productA < productB) ? -1 : (productA > productB) ? 1 : 0;
        });
    } else {
        // Sort product items based on data-popular attribute
        wineProducts.sort(function (a, b) {
            const productA = parseInt($(a).data('popular'));
            const productB = parseInt($(b).data('popular'));
            return productA - productB; // Sort in ascending order
        });
    }

    // Clear the container
    $('.product-list-wrapper').empty();

    // Append sorted items to container
    $.each(wineProducts, function (index, product) {
        $('.product-list-wrapper').append(product);
    });
}

// Remove from applied filters data
function removeFilterItems(dataObject) {
    const attrName = dataObject.dataset;
    let attrType = '';
    let attrKey = '';
    if (Object.keys(attrName)[0] == 'typeFilter') {
        attrKey = 'typeFilter';
        attrType = 'type-filter';
    } else {
        attrKey = Object.keys(attrName)[0];
        attrType = Object.keys(attrName)[0];
    }
    const attrValue = attrName[attrKey].toLowerCase();
    const dataIndex = appliedFilter.findIndex(item => item.type === attrType && item.value === attrValue);
    if (dataIndex !== -1) {
        appliedFilter.splice(dataIndex, 1);
        if(appliedFilter.length > 0) {
            filterByAttribute(appliedFilter);
        } else {
            resetFilter();
        }
    }
}

function resetFilter() {
    // Reset the type selection
    if($('.filter-button').hasClass('active-filter')) {
        $('.filter-button').removeClass('active-filter');
        $('.filter-button').find('i').remove();
    }
    $('.filter-variants-button').prop('checked', false);
    appliedFilter = [];
    // Show all div elements
    wineProducts.each(function () {
        $(this).show();
    });
}

function checkFilterArray(array, newFilterItem) {
    return array.some(filterItem => filterItem.type === newFilterItem.type && filterItem.value === newFilterItem.value);
}

function FetchUniqueAttributes(attrData, attrName) {
    if (attrData) {
        const attrValues = attrData.split(',');
        attrValues.forEach(function (value) {
            if (attrName.indexOf(value.trim()) === -1) {
                attrName.push(value.trim());
            }
        });
    }
}

function injectTypeFilter(wrapperName,typeFilterData) {
    typeFilterData.forEach(filter => {
        let filterAltName = '';
        if(filter == 'rose') {
            filterAltName = 'rosé';
        } else {
            filterAltName = filter;
        }
        const typeFilterSnippet = `<div role="button" data-type-filter="${filter}"
             class="filter-button item-filter-types w-6/12 mb-4 flex row items-center w-fit md:w-max md:mr-4 mr-2 md:mr-0">
            <img class="w-[32px] h-[32px]" src="/wp-content/themes/villamariawines-wp-theme/resources/icons/filters-${filter}.png"/>
            <div class="text-neutral-800 text-xs font-semibold font-['Avenir_Next'] uppercase leading-3 tracking-wide px-1 pt-1">
                ${filterAltName}
            </div>
        </div>`;

        // Append the filter data
        wrapperName.append(typeFilterSnippet);
    });
}

function injectFilters(wrapperName, filterData,attrName) {
    // Empty the div first
    wrapperName.empty();
    filterData.forEach(filter => {
        let filterAltName = '';
        if(filter == 'rose') {
            filterAltName = 'rosé';
        } else {
            filterAltName = filter;
        }
        const trimmedFilter = filterAltName.trim().replace(/-/g, " ");
        const filterSnippet = `<div class="justify-start items-center gap-2 inline-flex">
            <input
                class="filter-variants-button item-regions-checkbox relative float-left h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:bg-blue-500"
                type="checkbox"
                data-${attrName}="${filter}"
                value="${filter}">
            <label
                class="inline-block pl-[0.15rem] hover:cursor-pointer text-neutral-800 text-xs font-semibold font-['Avenir_Next'] uppercase leading-3 tracking-wide"
                for="item_regions_<?php echo $index ?>">
                ${trimmedFilter}
            </label>
        </div>`;
        // Append the filter data
        wrapperName.append(filterSnippet);
    });
}

function UpdateFilterBasedOnURL() {
    // Iterate through the data object
    for (let key in queryParams) {
        if (queryParams.hasOwnProperty(key)) {
            let filterItem = new Set();
            let filterObject = {};
            if(key == 'type') {
                // trigger the type filter
                filterItem = $('.filter-button[data-type-filter="' + queryParams[key] + '"]');
                // Create an <i> element
                const icon = $('<i>');

                // Add classes or attributes to the <i> element if needed
                icon.addClass('removeFilter-icon'); // Add a custom class for styling

                // Set the background image
                icon.css('background-image', 'url("/wp-content/themes/villamariawines-wp-theme/resources/icons/close.svg")');
                filterItem.append(icon);
                filterItem.addClass('active-filter');

                filterObject = {
                    type: 'type-filter',
                    value: queryParams[key].toLowerCase()
                }
            } else {
                // trigger variants filter
                filterItem = $('.filter-variants-button[data-'+key+'="' + queryParams[key] + '"]');
                filterItem.prop('checked', true);
                filterObject = {
                    type: key,
                    value: queryParams[key].toLowerCase()
                }
            }
            if (!checkFilterArray(appliedFilter, filterObject)) {
                appliedFilter.push(filterObject);
            }
        }
    }
    filterByAttribute(appliedFilter);
}
